/**
 * @ts-nocheck
 * This file was auto-generated from docs/openapi.yaml by openapi-zod-client.
 * Do not make direct changes to the file.
 */

import { makeApi, Zodios, type ZodiosOptions } from "@zodios/core";
import { z } from "zod";

const postApiceremoniescomplete_Body = z
  .object({ event_id: z.string(), qr_code_id: z.string() })
  .partial()
  .passthrough();
const postApicheckins_Body = z
  .object({
    event_id: z.string(),
    gps_lat: z.number(),
    gps_lng: z.number(),
    qr_code_id: z.string(),
  })
  .partial()
  .passthrough();
const postApiconfessions_Body = z
  .object({
    event_id: z.string(),
    qr_code_id: z.string(),
    text_content: z.string(),
  })
  .partial()
  .passthrough();
export const APIError = z
  .object({
    code: z.string(),
    fields: z.record(z.string()),
    message: z.string(),
  })
  .partial()
  .passthrough();
export const APIEnvelope = z
  .object({ data: z.unknown(), error: APIError, meta: z.record(z.string()) })
  .partial()
  .passthrough();
export const APIFeaturesResponse = z
  .object({ flags: z.record(z.boolean()) })
  .partial()
  .passthrough();
const postApihint_Body = z
  .object({ qr_code_id: z.string(), quest_id: z.string() })
  .partial()
  .passthrough();
const postApilocationupdate_Body = z
  .object({
    accuracy_m: z.number(),
    lat: z.number(),
    lng: z.number(),
    source: z.string(),
  })
  .partial()
  .passthrough();
const postApimessages_Body = z
  .object({ event_id: z.string(), faction_id: z.string(), message: z.string() })
  .partial()
  .passthrough();
const postApimomentinitiate_Body = z
  .object({
    title: z.string(),
    broadcast_message: z.string(),
    mood_colour: z.enum(["intense", "joyful", "calm", "mysterious", "sacred"]),
    qr_code_id: z.string(),
  })
  .partial()
  .passthrough();
export const PlayerMapMarkersResponse = z
  .object({
    legend_types: z.array(z.object({}).partial().passthrough()),
    map_config: z.object({}).partial().passthrough(),
    markers: z.array(z.object({}).partial().passthrough()),
  })
  .partial()
  .passthrough();
export const PlayerMapMarkersEnvelope = APIEnvelope.and(
  z.object({ data: PlayerMapMarkersResponse }).partial().passthrough()
);
export const ProfileJourneyEntry = z
  .object({
    CrossedAt: z.string().datetime({ offset: true }),
    CrossedAtLabel: z.string(),
    JourneyLabel: z.string(),
    LocationName: z.string(),
    PhaseName: z.string(),
    ThresholdID: z.string(),
  })
  .partial()
  .passthrough();
export const ProfileJourneyResponse = z
  .object({ count: z.number().int(), journey: z.array(ProfileJourneyEntry) })
  .partial()
  .passthrough();
export const ProfileJourneyEnvelope = APIEnvelope.and(
  z.object({ data: ProfileJourneyResponse }).partial().passthrough()
);
const postApisubmissions_Body = z
  .object({
    event_id: z.string(),
    gps_lat: z.number(),
    gps_lng: z.number(),
    photo: z.instanceof(File),
    qr_code_id: z.string(),
    quest_id: z.string(),
    scanned_badge_pid: z.string(),
    text_content: z.string(),
  })
  .partial()
  .passthrough();
const postApithresholdcross_Body = z
  .object({ qr_code_id: z.string(), reflection: z.string() })
  .partial()
  .passthrough();
const postApitokensaward_Body = z
  .object({
    amount: z.number().int(),
    event_id: z.string(),
    participant_id: z.string(),
  })
  .partial()
  .passthrough();
export const VersionResponse = z
  .object({ version: z.string(), app_url: z.string() })
  .partial()
  .passthrough();
const postApivote_Body = z
  .object({ choice: z.string(), event_id: z.string(), qr_code_id: z.string() })
  .partial()
  .passthrough();
export const PortDefinition = z
  .object({
    description: z.string(),
    type: z.string(),
    key: z.string(),
    label: z.string(),
    required: z.boolean(),
  })
  .partial()
  .passthrough();
export const NodeDefinition = z
  .object({
    summary: z.string(),
    description: z.string(),
    category: z.string(),
    complexity_level: z.string(),
    config_schema: z.object({}).partial().passthrough(),
    input_ports: z.array(PortDefinition),
    intent_category: z.string(),
    label: z.string(),
    output_ports: z.array(PortDefinition),
    palette_group: z.string(),
    participant_description: z.string(),
    read_scopes: z.array(z.string()),
    runtime_capabilities: z.array(z.string()),
    type_key: z.string(),
    ui_hints: z.object({}).partial().passthrough(),
    write_scopes: z.array(z.string()),
  })
  .partial()
  .passthrough();
export const WorkflowCatalogResponse = z
  .object({ version: z.string(), nodes: z.array(NodeDefinition) })
  .partial()
  .passthrough();
export const GMMapParticipant = z
  .object({
    faction_color: z.string(),
    faction_name: z.string(),
    id: z.string(),
    last_seen: z.string().datetime({ offset: true }),
    last_seen_relative: z.string(),
    lat: z.number(),
    lng: z.number(),
    name: z.string(),
    share_location: z.boolean(),
  })
  .partial()
  .passthrough();
export const GMMapParticipantsResponse = z
  .object({ participants: z.array(GMMapParticipant) })
  .partial()
  .passthrough();
export const GMMapParticipantsEnvelope = APIEnvelope.and(
  z.object({ data: GMMapParticipantsResponse }).partial().passthrough()
);
const postGmfactionsactionssave_Body = z
  .object({
    summary: z.string(),
    title: z.string(),
    action_family: z.string(),
    action_id: z.string(),
    capacity_delta: z.number().int(),
    ceremony_minutes: z.number().int(),
    ceremony_text: z.string(),
    incident_severity: z.string(),
    incident_summary: z.string(),
    message_body: z.string(),
    message_title: z.string(),
    peer_faction_id: z.string(),
    primary_faction_id: z.string(),
    target_scope: z.string(),
    token_delta: z.number().int(),
    trigger_day: z.number().int(),
    trigger_family: z.string(),
    trigger_value: z.number().int(),
  })
  .partial()
  .passthrough();
const postGmfactionsgrantTokens_Body = z
  .object({
    amount: z.number().int(),
    faction_id: z.string(),
    reason: z.string(),
    return_to: z.string(),
  })
  .partial()
  .passthrough();
const postGmfactionsIdbroadcast_Body = z
  .object({ title: z.string(), body: z.string() })
  .partial()
  .passthrough();
const postGmfactionsIdrebalance_Body = z
  .object({
    title: z.string(),
    capacity_delta: z.number().int(),
    ceremony_minutes: z.number().int(),
    ceremony_text: z.string(),
    incident_severity: z.string(),
    incident_summary: z.string(),
    mode: z.string(),
    token_delta: z.number().int(),
  })
  .partial()
  .passthrough();
export const ItemInUseCheckResponse = z
  .object({ in_use: z.boolean() })
  .partial()
  .passthrough();
const postGmlivingBooksrequestsIdmove_Body = z
  .object({ move_reason: z.string(), target_book_id: z.string() })
  .partial()
  .passthrough();
export const PlannerResourceSuggestion = z
  .object({ detail: z.string(), id: z.string(), label: z.string() })
  .partial()
  .passthrough();
export const PlannerResourceSuggestionsResponse = z
  .object({ items: z.array(PlannerResourceSuggestion) })
  .partial()
  .passthrough();
export const PlannerResourceSuggestionsEnvelope = APIEnvelope.and(
  z.object({ data: PlannerResourceSuggestionsResponse }).partial().passthrough()
);
const postGmquestionsWall_iddisplayreorder_Body = z
  .object({
    question_id: z.array(z.string()),
    rotation_seconds: z.number().int(),
  })
  .partial()
  .passthrough();
const postGmquestionsWall_idthreadsIdassign_Body = z
  .object({
    assignee_id: z.string(),
    assignment_role: z.string(),
    notes: z.string(),
  })
  .partial()
  .passthrough();
const postGmworkflowsId_Body = z
  .object({
    description: z.string(),
    document_json: z.string(),
    name: z.string(),
    status: z.string(),
  })
  .partial()
  .passthrough();
export const WorkflowSaveResponse = z
  .object({ message: z.string(), saved: z.boolean(), workflow_id: z.string() })
  .partial()
  .passthrough();
export const WorkflowSaveEnvelope = APIEnvelope.and(
  z.object({ data: WorkflowSaveResponse }).partial().passthrough()
);
export const WorkflowValidationResponse = z
  .object({ issues: z.array(z.string()), valid: z.boolean() })
  .partial()
  .passthrough();
export const WorkflowValidationEnvelope = APIEnvelope.and(
  z.object({ data: WorkflowValidationResponse }).partial().passthrough()
);
export const HealthStatusResponse = z
  .object({ status: z.string() })
  .partial()
  .passthrough();

export const schemas = {
  postApiceremoniescomplete_Body,
  postApicheckins_Body,
  postApiconfessions_Body,
  APIError,
  APIEnvelope,
  APIFeaturesResponse,
  postApihint_Body,
  postApilocationupdate_Body,
  postApimessages_Body,
  postApimomentinitiate_Body,
  PlayerMapMarkersResponse,
  PlayerMapMarkersEnvelope,
  ProfileJourneyEntry,
  ProfileJourneyResponse,
  ProfileJourneyEnvelope,
  postApisubmissions_Body,
  postApithresholdcross_Body,
  postApitokensaward_Body,
  VersionResponse,
  postApivote_Body,
  PortDefinition,
  NodeDefinition,
  WorkflowCatalogResponse,
  GMMapParticipant,
  GMMapParticipantsResponse,
  GMMapParticipantsEnvelope,
  postGmfactionsactionssave_Body,
  postGmfactionsgrantTokens_Body,
  postGmfactionsIdbroadcast_Body,
  postGmfactionsIdrebalance_Body,
  ItemInUseCheckResponse,
  postGmlivingBooksrequestsIdmove_Body,
  PlannerResourceSuggestion,
  PlannerResourceSuggestionsResponse,
  PlannerResourceSuggestionsEnvelope,
  postGmquestionsWall_iddisplayreorder_Body,
  postGmquestionsWall_idthreadsIdassign_Body,
  postGmworkflowsId_Body,
  WorkflowSaveResponse,
  WorkflowSaveEnvelope,
  WorkflowValidationResponse,
  WorkflowValidationEnvelope,
  HealthStatusResponse,
};

export const endpoints = makeApi([
  {
    method: "post",
    path: "/api/ceremonies/complete",
    alias: "postApiceremoniescomplete",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApiceremoniescomplete_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/api/checkins",
    alias: "postApicheckins",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApicheckins_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/api/confessions",
    alias: "postApiconfessions",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApiconfessions_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/api/event/day-status",
    alias: "getApieventdayStatus",
    requestFormat: "json",
    response: APIEnvelope,
  },
  {
    method: "get",
    path: "/api/features",
    alias: "getApifeatures",
    requestFormat: "json",
    response: APIEnvelope.and(
      z.object({ data: APIFeaturesResponse }).partial().passthrough()
    ),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/api/hint",
    alias: "postApihint",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApihint_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/api/location/faction-members",
    alias: "getApilocationfactionMembers",
    requestFormat: "json",
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/location/share",
    alias: "postApilocationshare",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z
          .object({ share_location: z.boolean() })
          .partial()
          .passthrough(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/location/update",
    alias: "postApilocationupdate",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApilocationupdate_Body,
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/messages",
    alias: "postApimessages",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApimessages_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/api/moment/:session_id/witness",
    alias: "postApimomentSession_idwitness",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z
          .object({ emoji: z.string() })
          .partial()
          .passthrough()
          .optional(),
      },
      {
        name: "session_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/moment/initiate",
    alias: "postApimomentinitiate",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApimomentinitiate_Body,
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "get",
    path: "/api/participants/search",
    alias: "getApiparticipantssearch",
    requestFormat: "json",
    parameters: [
      {
        name: "q",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "get",
    path: "/api/play/map/markers",
    alias: "getApiplaymapmarkers",
    requestFormat: "json",
    response: PlayerMapMarkersEnvelope,
  },
  {
    method: "get",
    path: "/api/profile/journey",
    alias: "getApiprofilejourney",
    requestFormat: "json",
    response: ProfileJourneyEnvelope,
  },
  {
    method: "get",
    path: "/api/qr/:code",
    alias: "getApiqrCode",
    requestFormat: "json",
    parameters: [
      {
        name: "code",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/api/question/:qr_code_id/submit",
    alias: "postApiquestionQr_code_idsubmit",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({ text: z.string() }).partial().passthrough(),
      },
      {
        name: "qr_code_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/question/:question_id/resonate",
    alias: "postApiquestionQuestion_idresonate",
    requestFormat: "json",
    parameters: [
      {
        name: "question_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/question/:question_id/respond",
    alias: "postApiquestionQuestion_idrespond",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({ text: z.string() }).partial().passthrough(),
      },
      {
        name: "question_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/submissions",
    alias: "postApisubmissions",
    requestFormat: "form-data",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApisubmissions_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/api/threshold/cross",
    alias: "postApithresholdcross",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApithresholdcross_Body,
      },
    ],
    response: APIEnvelope,
  },
  {
    method: "post",
    path: "/api/tokens/award",
    alias: "postApitokensaward",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApitokensaward_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/api/version",
    alias: "getApiversion",
    requestFormat: "json",
    response: APIEnvelope.and(
      z.object({ data: VersionResponse }).partial().passthrough()
    ),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/api/vote",
    alias: "postApivote",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postApivote_Body,
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/api/workflows/catalog",
    alias: "getGmapiworkflowscatalog",
    requestFormat: "json",
    response: APIEnvelope.and(
      z.object({ data: WorkflowCatalogResponse }).partial().passthrough()
    ),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
      {
        status: 401,
        description: `Unauthorized`,
        schema: z.void(),
      },
      {
        status: 422,
        description: `Application error: AUTH_REQUIRED | EVENT_NOT_FOUND`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/beacons",
    alias: "getGmbeacons",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/beacons/:id/deactivate",
    alias: "postGmbeaconsIddeactivate",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/beacons/:id/update",
    alias: "postGmbeaconsIdupdate",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/beacons/activity",
    alias: "getGmbeaconsactivity",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/beacons/detail",
    alias: "getGmbeaconsdetail",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/beacons/quick-create",
    alias: "postGmbeaconsquickCreate",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/beacons/snapshot",
    alias: "getGmbeaconssnapshot",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/chronicle",
    alias: "getGmchronicle",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/chronicle/entries/:id/archive",
    alias: "postGmchronicleentriesIdarchive",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the GM chronicle workspace with archive confirmation`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/chronicle/entries/:id/publish",
    alias: "postGmchronicleentriesIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the GM chronicle workspace with publish confirmation`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/chronicle/entries/save",
    alias: "postGmchronicleentriessave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the GM chronicle workspace with a flash message`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/chronicle/preview",
    alias: "postGmchroniclepreview",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/events/:id/map/participants",
    alias: "getGmeventsIdmapparticipants",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: GMMapParticipantsEnvelope,
  },
  {
    method: "post",
    path: "/gm/factions/:id/broadcast",
    alias: "postGmfactionsIdbroadcast",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmfactionsIdbroadcast_Body,
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/:id/rebalance",
    alias: "postGmfactionsIdrebalance",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmfactionsIdrebalance_Body,
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/factions/actions/:id",
    alias: "getGmfactionsactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/factions/actions/:id/publish",
    alias: "postGmfactionsactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/actions/:id/run-now",
    alias: "postGmfactionsactionsIdrunNow",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/actions/save",
    alias: "postGmfactionsactionssave",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmfactionsactionssave_Body,
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/ceremonies/:id/complete",
    alias: "postGmfactionsceremoniesIdcomplete",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/ceremonies/:id/start",
    alias: "postGmfactionsceremoniesIdstart",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/factions/grant-tokens",
    alias: "postGmfactionsgrantTokens",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmfactionsgrantTokens_Body,
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the faction studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/factions/live-balance",
    alias: "getGmfactionsliveBalance",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/factions/studio",
    alias: "getGmfactionsstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/items/:id/check",
    alias: "getGmitemsIdcheck",
    requestFormat: "json",
    response: z.object({ in_use: z.boolean() }).partial().passthrough(),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
      {
        status: 401,
        description: `Unauthorized`,
        schema: z.void(),
      },
      {
        status: 422,
        description: `Application error: AUTH_REQUIRED | EVENT_NOT_FOUND`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/items/recipes",
    alias: "getGmitemsrecipes",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/items/recipes/actions/:id",
    alias: "getGmitemsrecipesactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/items/recipes/actions/:id/publish",
    alias: "postGmitemsrecipesactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to recipe studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/items/recipes/actions/:id/run-now",
    alias: "postGmitemsrecipesactionsIdrunNow",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to recipe studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/items/recipes/actions/save",
    alias: "postGmitemsrecipesactionssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to recipe studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/items/recipes/crafts/:id/approve",
    alias: "postGmitemsrecipescraftsIdapprove",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to recipe studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/items/recipes/crafts/:id/refund",
    alias: "postGmitemsrecipescraftsIdrefund",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to recipe studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/items/recipes/live",
    alias: "getGmitemsrecipeslive",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/items/recipes/studio",
    alias: "getGmitemsrecipesstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/living-books",
    alias: "getGmlivingBooks",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/living-books/actions/:id",
    alias: "getGmlivingBooksactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/living-books/actions/:id/publish",
    alias: "postGmlivingBooksactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/actions/save",
    alias: "postGmlivingBooksactionssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/books/:id/pause",
    alias: "postGmlivingBooksbooksIdpause",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z
          .object({ pause_reason: z.string() })
          .partial()
          .passthrough()
          .optional(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/living-books/queue",
    alias: "getGmlivingBooksqueue",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/living-books/requests/:id/approve",
    alias: "postGmlivingBooksrequestsIdapprove",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library queue`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/requests/:id/decline",
    alias: "postGmlivingBooksrequestsIddecline",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z
          .object({ decline_reason: z.string() })
          .partial()
          .passthrough()
          .optional(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library queue`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/requests/:id/end",
    alias: "postGmlivingBooksrequestsIdend",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library sessions`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/requests/:id/move",
    alias: "postGmlivingBooksrequestsIdmove",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmlivingBooksrequestsIdmove_Body,
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library queue`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/living-books/studio",
    alias: "getGmlivingBooksstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/living-books/templates/:id/publish",
    alias: "postGmlivingBookstemplatesIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/living-books/templates/save",
    alias: "postGmlivingBookstemplatessave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to living library studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/planner/resources/suggest",
    alias: "getGmplannerresourcessuggest",
    requestFormat: "json",
    parameters: [
      {
        name: "resource_type",
        type: "Query",
        schema: z.string().optional(),
      },
      {
        name: "q",
        type: "Query",
        schema: z.string().optional(),
      },
    ],
    response: PlannerResourceSuggestionsEnvelope,
  },
  {
    method: "get",
    path: "/gm/preview",
    alias: "getGmpreview",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/preview/exit",
    alias: "postGmpreviewexit",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects back to the GM preview page or return target`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/preview/new",
    alias: "getGmpreviewnew",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/preview/new",
    alias: "postGmpreviewnew",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirects into the participant surface with preview active`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/questions",
    alias: "getGmquestions",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/questions/:wall_id/display/reorder",
    alias: "postGmquestionsWall_iddisplayreorder",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmquestionsWall_iddisplayreorder_Body,
      },
      {
        name: "wall_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions display panel`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/questions/:wall_id/threads/:id/archive",
    alias: "postGmquestionsWall_idthreadsIdarchive",
    requestFormat: "json",
    parameters: [
      {
        name: "wall_id",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions moderation`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/questions/:wall_id/threads/:id/assign",
    alias: "postGmquestionsWall_idthreadsIdassign",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmquestionsWall_idthreadsIdassign_Body.optional(),
      },
      {
        name: "wall_id",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions moderation`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/questions/:wall_id/threads/:id/hold",
    alias: "postGmquestionsWall_idthreadsIdhold",
    requestFormat: "json",
    parameters: [
      {
        name: "wall_id",
        type: "Path",
        schema: z.string(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions moderation`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/questions/actions/:id",
    alias: "getGmquestionsactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/questions/actions/:id/publish",
    alias: "postGmquestionsactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/questions/actions/save",
    alias: "postGmquestionsactionssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/questions/moderation",
    alias: "getGmquestionsmoderation",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/questions/studio",
    alias: "getGmquestionsstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/questions/templates/:id/publish",
    alias: "postGmquestionstemplatesIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/questions/templates/save",
    alias: "postGmquestionstemplatessave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to questions studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/readiness",
    alias: "getGmreadiness",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/readiness/actions/activate-drafts",
    alias: "postGmreadinessactionsactivateDrafts",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to the readiness page after activating draft QR codes`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/readiness/snapshot",
    alias: "getGmreadinesssnapshot",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/skills",
    alias: "getGmskills",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/skills/actions/:id",
    alias: "getGmskillsactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/skills/actions/:id/publish",
    alias: "postGmskillsactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/actions/save",
    alias: "postGmskillsactionssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/blocks/:id/open-backup",
    alias: "postGmskillsblocksIdopenBackup",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/blocks/save",
    alias: "postGmskillsblockssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/categories/:key/close-intake",
    alias: "postGmskillscategoriesKeycloseIntake",
    requestFormat: "json",
    parameters: [
      {
        name: "key",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/categories/:key/open-intake",
    alias: "postGmskillscategoriesKeyopenIntake",
    requestFormat: "json",
    parameters: [
      {
        name: "key",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/exams/:id/issue-cert",
    alias: "postGmskillsexamsIdissueCert",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/skills/live",
    alias: "getGmskillslive",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/skills/matches/:id/rematch",
    alias: "postGmskillsmatchesIdrematch",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/run-matching",
    alias: "postGmskillsrunMatching",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/skills/studio",
    alias: "getGmskillsstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/skills/templates/:id/publish",
    alias: "postGmskillstemplatesIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/skills/templates/save",
    alias: "postGmskillstemplatessave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to skills studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/workflows/:id",
    alias: "postGmworkflowsId",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: postGmworkflowsId_Body,
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: WorkflowSaveEnvelope,
  },
  {
    method: "post",
    path: "/gm/workflows/:id/validate",
    alias: "postGmworkflowsIdvalidate",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({ document_json: z.string() }).partial().passthrough(),
      },
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: WorkflowValidationEnvelope,
  },
  {
    method: "get",
    path: "/gm/workshops",
    alias: "getGmworkshops",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/workshops/:session_id/delay",
    alias: "postGmworkshopsSession_iddelay",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z
          .object({ delay_minutes: z.number().int() })
          .partial()
          .passthrough()
          .optional(),
      },
      {
        name: "session_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop live panel`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/workshops/:session_id/reassign-host",
    alias: "postGmworkshopsSession_idreassignHost",
    requestFormat: "form-url",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: z.object({ host_user_id: z.string() }).partial().passthrough(),
      },
      {
        name: "session_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop live panel`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/workshops/:session_id/remind",
    alias: "postGmworkshopsSession_idremind",
    requestFormat: "json",
    parameters: [
      {
        name: "session_id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop live panel`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/workshops/actions/:id",
    alias: "getGmworkshopsactionsId",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/workshops/actions/:id/publish",
    alias: "postGmworkshopsactionsIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/workshops/actions/save",
    alias: "postGmworkshopsactionssave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/gm/workshops/live",
    alias: "getGmworkshopslive",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/gm/workshops/studio",
    alias: "getGmworkshopsstudio",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "post",
    path: "/gm/workshops/templates/:id/publish",
    alias: "postGmworkshopstemplatesIdpublish",
    requestFormat: "json",
    parameters: [
      {
        name: "id",
        type: "Path",
        schema: z.string(),
      },
    ],
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "post",
    path: "/gm/workshops/templates/save",
    alias: "postGmworkshopstemplatessave",
    requestFormat: "json",
    response: z.void(),
    errors: [
      {
        status: 303,
        description: `Redirect back to workshop studio`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/healthz",
    alias: "getHealthz",
    requestFormat: "json",
    response: APIEnvelope.and(
      z.object({ data: HealthStatusResponse }).partial().passthrough()
    ),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
      {
        status: 422,
        description: `Application error: SYSTEM_INTERNAL`,
        schema: z.void(),
      },
    ],
  },
  {
    method: "get",
    path: "/metrics",
    alias: "getMetrics",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/participant/chronicle",
    alias: "getParticipantchronicle",
    requestFormat: "json",
    response: z.void(),
  },
  {
    method: "get",
    path: "/participant/chronicle/export",
    alias: "getParticipantchronicleexport",
    requestFormat: "json",
    parameters: [
      {
        name: "format",
        type: "Query",
        schema: z.enum(["html", "pdf"]),
      },
    ],
    response: z.void(),
  },
  {
    method: "get",
    path: "/readyz",
    alias: "getReadyz",
    requestFormat: "json",
    response: APIEnvelope.and(
      z.object({ data: HealthStatusResponse }).partial().passthrough()
    ),
    errors: [
      {
        status: 400,
        description: `Bad request`,
        schema: z.void(),
      },
      {
        status: 422,
        description: `Application error: DB_UNAVAILABLE | STORAGE_UNAVAILABLE`,
        schema: z.void(),
      },
    ],
  },
]);

export const api = new Zodios(endpoints);

export function createApiClient(baseUrl: string, options?: ZodiosOptions) {
  return new Zodios(baseUrl, endpoints, options);
}
